const POINT_PARAMETER_DEVIDER_SIGN = "|";
const POINT_PARAMETER_COUNT = 5;

export default class ParsedPoint {
  constructor({ type, cityId, lat, lon, address }) {
    this.type = type;
    this.cityId = cityId;
    this.geoPoint = lat !== undefined && lon !== undefined ? {
      lat,
      lon,
    } : undefined;
    this.address = address;
  }

  static parse = parseStr => {
    const pointParams = parseStr.split(POINT_PARAMETER_DEVIDER_SIGN);
    if (pointParams.length !== POINT_PARAMETER_COUNT) {
      return undefined;
    }
    try {
      const type = parseInt(pointParams[0], 10); // обязательный
      const cityId = pointParams[1] ? parseInt(pointParams[1], 10) : undefined; // необязательный
      const lat = pointParams[2] ? parseFloat(pointParams[2]) : undefined; // необязательный, но работает в паре с lon
      const lon = pointParams[3] ? parseFloat(pointParams[3]) : undefined; // необязательный, но работает в паре с lat
      const address = pointParams[4] || undefined; // необязательный, но работает в паре с lat/lon.

      if (lat && !lon || lon && !lat) {
        return undefined;
      }

      if (address && !(lat || lon)) {
        return undefined;
      }
      
      return new ParsedPoint({
        type: type,
        cityId: cityId,
        lat: lat,
        lon: lon,
        address: address,
      });
    } catch (e) {
      return undefined;
    }
  };
  
  toString = () => {
    const parts = Array(5);
    parts[0] = this.type;
    if(this.cityId){
      parts[1] = this.cityId;
    }
    if(this.geoPoint){
      parts[2] = this.geoPoint.lat;
      parts[3] = this.geoPoint.lon;
    }
    if(this.address){
      parts[4] = this.address;
    }
    return parts.join(POINT_PARAMETER_DEVIDER_SIGN);
  };
}
